import BaseCheckbox from '@material-ui/core/Checkbox'

const Checkbox = BaseCheckbox

export default Checkbox
